import { useRef, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import PhoneDetails, { PhoneHandler } from './phone-details';
import { useMutation } from '@apollo/client';
import { CREATE_ORG_CONTACT_PHONE, GET_ORG_CONTACT_PHONES } from '../../../../graphql/contact-gql';
import SpinnerOverlay from '../../../common/spinner/spinner';
import { notifySuccess } from '../../../../services/notification';
import { AddIcon, CancelIcon } from '../../../common/icons';
import Button from '../../../common/button';

type PhoneCreateProps = {
    orgId: number;
    isOpen: boolean;
    toggle: () => void;
}

const PhoneCreate = (props: PhoneCreateProps) => {
    const {isOpen, toggle, orgId } = props

    const contactRef = useRef<PhoneHandler>(null)
    const [createContactPhone, { loading }] = useMutation(CREATE_ORG_CONTACT_PHONE)

    const [validated, setValidated] = useState<boolean>(false)

    const onCreateContactPhone = () => {
        if (contactRef.current && !contactRef.current.validate(true)) {
            setValidated(false)
            return
        }

        let contactPhoneInput = contactRef.current && contactRef.current.getContactPhone()
        createContactPhone({
            variables: {
                orgId: orgId,
                input: contactPhoneInput
            },
            refetchQueries: [{
                query: GET_ORG_CONTACT_PHONES,
                variables: { orgId: orgId }
            }],
            awaitRefetchQueries: true,
            onCompleted: (data) => {
                toggle()
                data && notifySuccess()
            }
        })
    }

    const onToggle = (event: any) => {
        if (event.target.nodeName !== 'SELECT') {
            toggle()
        }
    }

    const onChange = () => {
        setValidated(!!contactRef.current?.validate(false))
    }

    return (<>
        {loading && <SpinnerOverlay />}
        <Modal size="lg" isOpen={isOpen} toggle={onToggle} scrollable autoFocus={false}>
            <ModalHeader toggle={toggle} tag={'h2'}>Add an Organization Phone Number</ModalHeader>
            <ModalBody>
                <PhoneDetails ref={contactRef} isOrgPhone={true} onChange={onChange} autoFocus={true}/>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={onCreateContactPhone} disabled={!validated}><AddIcon/>Add</Button>
                <Button color="secondary" onClick={toggle}><CancelIcon/>Cancel</Button>
            </ModalFooter>
        </Modal>
        </>
  )
}

export default PhoneCreate
